import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Tab } from "react-bootstrap";
import { Grid, Skeleton } from "@mui/material";

import noReportImage from "../../../image/profile/empty-list.png";
import { messageApi, simReportApi } from "../../../utility/api/apiList";

import useAxios from "../../../hooks/useAxios";
import useFilter from "../../../hooks/useFilter";
import { calculatePageSize } from "../../../libs/pagingDetail";
import scrollToTop from "../../../libs/scrollToTop";

import StudentsReportComponent from "../../../components/private/user/userReportComponent/studentReportComponent";
import UserTabsComponent from "../../../components/private/tabs";
import MyReportComponent from "../../../components/private/user/userReportComponent/myReportComponent";
import UserResponsiveHeaderComponent from "../../../components/private/user/userReponsiveHeader";
import PaginationComponent from "../../../components/public/pagination";

import { ReportContainer } from "./styledUserReportContainer";
import { ReportRows } from "../../../components/private/user/userReportComponent/styledUserReport";

const UserReportContainer = () => {
  const [activeTabKey, setActiveTabKey] = useState("studentReport");

  const { onChange, filterState } = useFilter();
  const userRole = useSelector((state) => state.userDetail.userRole);

  const isStudentReportTab = activeTabKey === "studentReport";
  const isTeacher = userRole === "teacher" ? true : false;
  const page_size = 10;

  useEffect(() => {
    document.title = "تغییر رمز";
    scrollToTop();
  }, []);

  const {
    data: myReports,
    isLoaded: myReportsIsLoaded,
    run: myReportsRun,
  } = useAxios({
    url: simReportApi,
    params: {
      order_by: "finish_at",
      page_size,
      page: filterState["page"],
    },
  });

  const {
    data: studentReports,
    isLoaded: studentReportIsLoaded,
    run: studentReportRun,
  } = useAxios({
    url: messageApi,
    params: {
      filter_type: 4,
      order_by: "-id",
      page_size,
      page: filterState["page"],
    },
  });

  useEffect(() => {
    if (isTeacher && isStudentReportTab) {
      studentReportRun();
    } else {
      myReportsRun().then();
    }
  }, [activeTabKey, filterState["page"]]);

  const handleTabPush = (key) => {
    onChange("tab", key);
    setActiveTabKey(key);
  };

  const tabs = [
    {
      id: 1,
      title: "گزارشکار دانش‌آموزان",
      eventKey: "studentReport",
      component: (
        <StudentsReportComponent
          reports={studentReports?.results}
          loading={studentReportIsLoaded}
        />
      ),
    },
    {
      id: 2,
      title: "گزارشکار من",
      eventKey: "myLabReport",
      component: (
        <MyReportComponent reports={myReports?.results?.slice(0)?.reverse()} />
      ),
    },
  ];

  const ReportTabs = () => {
    return (
      <>
        {isTeacher ? (
          <UserTabsComponent
            className={"my-4 p-0"}
            activeKey={activeTabKey}
            onSelect={(k) => handleTabPush(k)}
          >
            {tabs.map((item) => (
              <Tab key={item.id} title={item.title} eventKey={item.eventKey}>
                {item.component}
              </Tab>
            ))}
          </UserTabsComponent>
        ) : (
          <MyReportComponent reports={myReports?.results?.slice(0)?.reverse()} />
        )}
        <PaginationComponent
          pageNumber={calculatePageSize(
            isTeacher && isStudentReportTab
              ? studentReports?.count
              : myReports?.count,
            page_size
          )}
          currentPage={filterState["page"] || 1}
          handleChangePage={(e, value) => {
            onChange("page", value);
          }}
          className="mt-5"
          defaulPage={1}
        />
      </>
    );
  };

  const EmptyReportList = () => {
    return (
      <>
        {isTeacher ? (
          <UserTabsComponent
            className={"my-4 p-0"}
            activeKey={activeTabKey}
            onSelect={(k) => handleTabPush(k)}
          >
            {tabs.map((item) => (
              <Tab key={item.id} title={item.title} eventKey={item.eventKey}>
                <div className="text-center mt-5">
                  <p className="mt-5">
                    گزارشکاری تاکنون
                    {isTeacher && isStudentReportTab ? " ارسال " : "  ثبت "}
                    نشده است!
                  </p>
                  <img
                    src={noReportImage}
                    alt="no-report-image"
                    className="no-report-image img-fluid d-block mx-auto"
                  />
                </div>
              </Tab>
            ))}
          </UserTabsComponent>
        ) : (
          <div className="text-center mt-5">
            <p className="mt-5">گزارشکاری تاکنون ارسال نشده است!</p>
            <img
              src={noReportImage}
              alt="no-report-image"
              className="no-report-image img-fluid d-block mx-auto"
            />
          </div>
        )}
      </>
    );
  };

  const ReportSkeleton = () => {
    return (
      <div className="text-center mt-5">
        <ReportRows className="w-100 mb-3">
          <Grid item xs={12} lg={4}>
            <Skeleton variant="text" />
          </Grid>
          <Grid item xs={7} lg={4}>
            <Skeleton variant="text" />
          </Grid>
          <Grid item xs={5} lg={4}>
            <Skeleton variant="text" />
          </Grid>
        </ReportRows>
        <ReportRows className="w-100 mb-3">
          <Grid item xs={12} lg={4}>
            <Skeleton variant="text" />
          </Grid>
          <Grid item xs={7} lg={4}>
            <Skeleton variant="text" />
          </Grid>
          <Grid item xs={5} lg={4}>
            <Skeleton variant="text" />
          </Grid>
        </ReportRows>
        <ReportRows className="w-100 mb-3">
          <Grid item xs={12} lg={4}>
            <Skeleton variant="text" />
          </Grid>
          <Grid item xs={7} lg={4}>
            <Skeleton variant="text" />
          </Grid>
          <Grid item xs={5} lg={4}>
            <Skeleton variant="text" />
          </Grid>
        </ReportRows>
      </div>
    );
  };

  let element = null;
  const loading =
    isTeacher && isStudentReportTab ? !studentReportIsLoaded : !myReportsIsLoaded;

  if (loading) {
    element = <ReportSkeleton />;
  } else if (
    isTeacher && isStudentReportTab
      ? studentReports?.count === 0
      : myReports?.count === 0
  ) {
    element = <EmptyReportList />;
  } else {
    element = <ReportTabs />;
  }

  return (
    <ReportContainer>
      <UserResponsiveHeaderComponent />
      {element}
    </ReportContainer>
  );
};

export default UserReportContainer;
